export default __webpack_public_path__ + "static/dumpster-rental-banner-57f17d7d8c4d46520a2ee98e78328a36.jpg";